import type { PricingFormValues } from "./components/NewRequestDialog/pricing/schemas"

import type { GetSalesCustomerListQuery, GetSalesProductListQuery } from "@/graphql/codegen/graphql"

export type SalesCustomer = Extract<
  GetSalesCustomerListQuery["location"]["listBillingLocations"],
  { __typename: "BillingLocationListSuccess" }
>["billingLocations"][number]

export type SalesProduct = Extract<
  GetSalesProductListQuery["product"]["list"],
  { __typename: "ProductListSuccess" }
>["products"][number]

export interface SalesRequester {
  contactId: string
  firstName: string
  lastName: string
}

export interface AddedProduct {
  product: SalesProduct
  requestQuote: boolean
  isExpanded: boolean
}

export enum NewRequestStep {
  Customer = "customer",
  Requester = "requester",
  Product = "product",
  Review = "review",
  SendToCustomer = "sendToCustomer",
}

export interface NewRequestFormValues {
  customer: SalesCustomer
  requesters: SalesRequester[]
  products?: AddedProduct[]
  pricingByProductId?: Map<number, PricingFormValues>
}
